import React from 'react';
import { DataCollectionGapSummaryQuestion } from '../../../../store/Models/Api/DataCollectionGapSummaryModels';
import { useLocalizer } from '../hooks/useLocalizer';

interface QuestionListProps {
    questions: DataCollectionGapSummaryQuestion[];
}

export const QuestionList: React.FC<QuestionListProps> = ({ questions }) => {
    const localize = useLocalizer();

    if (!questions?.length) {
        return null;
    }

    return (
        <ul className="gap-summary-question-list">
            {questions.map((question) => (
                <li key={`${question.index}-${question.text}`}>
                    <span className="gap-summary-question-status"></span>
                    <span>{localize(question.text)}</span>
                </li>
            ))}
        </ul>
    );
};

export default QuestionList;
